import {GameState} from './classes/gameState.js';
import {LevelState} from './classes/levelState.js';
import {SoundfxPlayer} from './utils/soundfx-player.js';
import {MusicPlayer} from './utils/music-player.js';

class StorageSpace13 {
    gameState: GameState;
    levelState: LevelState;
    soundFxPlayer: SoundfxPlayer;
    musicPlayer: MusicPlayer;
    constructor() {
        this.gameState = new GameState();
        this.levelState = new LevelState();
        this.soundFxPlayer = new SoundfxPlayer();
        this.musicPlayer = new MusicPlayer();
    }
}

export const storageSpace13 = new StorageSpace13();
